module.exports = __webpack_public_path__ + "b40e4adf260c340adbf63979ed0e188a.svg";